import React from 'react';
import PropTypes from 'prop-types';
import { route } from '../Util';
import CommunicationStyle from './CommunicationStyle';
import UserIcon from './UserIcon';
import { userShape } from '../propTypes';

function LargeUserPill({
  user,
  content = null,
}) {
  if (!user || !user.id) {
    return null;
  }

  let pronouns;
  if (user.pronouns) {
    pronouns = (
      <small className="text-muted ml-2" style={{ fontWeight: 'normal' }}>
        {user.pronouns}
      </small>
    );
  }

  let body = (
    <span className="small text-muted">
      {user.job ? user.job.title : ''}
    </span>
  );

  if (content) {
    body = content;
  }

  return (
    <a href={route.profile(user)} className="user-pill large">
      <div className="pill-inner">
        <div style={{ clear: 'both', paddingLeft: '55px' }}>
          <UserIcon
            user={user}
            size="48px"
            style={{
              left: 0,
              top: 0,
              position: 'absolute',
              borderRadius: '2px 48px 48px 2px',
            }}
          />

          <strong style={{ display: 'block', marginBottom: '-5px' }}>
            {user.name}
            {pronouns}
          </strong>

          {body}
        </div>

        {user.communication_style_sorted && (
          <CommunicationStyle size="h5" styles={user.communication_style_sorted} />
        )}
      </div>
    </a>
  );
}

LargeUserPill.propTypes = {
  user: userShape.isRequired,
  content: PropTypes.node,
};

LargeUserPill.defaultProps = {
  content: null,
};

export default LargeUserPill;
